import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import { Action } from '../data/useShareTargets';

ShareTargetCheckbox.propTypes = {
	children: PropTypes.string,
	isDisabled: PropTypes.bool,
	shareTargetsEditor: PropTypes.object,
	shareTarget: PropTypes.shape({
		id: PropTypes.number,
		type: PropTypes.string.isRequired,
	}),
};

ShareTargetCheckbox.defaultProps = {
	isDisabled: false,
};

export default function ShareTargetCheckbox({
	children,
	shareTarget,
	isDisabled,
	shareTargetsEditor,
}) {
	const onChange = evt => {
		const isChecked = evt.target.checked;

		const addAction = {
			type: Action.ADD_SHARE_TARGET,
			payload: { shareTarget },
		};

		const removeAction = {
			type: Action.REMOVE_SHARE_TARGET,
			payload: { shareTarget },
		};

		shareTargetsEditor.update(isChecked ? addAction : removeAction);
	};

	return (
		<div
			className="share-target-checkbox"
			style={{ marginBottom: '0.5rem' }}>
			<Checkbox
				onChange={onChange}
				disabled={isDisabled}
				checked={shareTargetsEditor.isActive(shareTarget)}>
				{children}
			</Checkbox>
		</div>
	);
}
